// extracted by mini-css-extract-plugin
var _1 = "WRVeX7xCtsXMANj0MigU";
export { _1 as "test" }
